import { PagenatedResponse } from '@models/common';
import { Product, ProductOption, ProductSearchQuery, ProductStatus } from '@models/product';
import { apiClient } from '.';

export const searchProducts = async (query?: ProductSearchQuery) => {
  return apiClient.get<PagenatedResponse<Product>>(`/partner/v1/products`, {
    params: query,
  });
};

export const getProduct = async (productId: string) => {
  return apiClient.get<Product>(`/partner/v1/products/${productId}`);
};

export const getDraftProduct = async (productId: string) => {
  return apiClient.get<Product>(`/partner/v1/products/${productId}/draft`);
};

export const createProduct = async (formData: FormData) => {
  return apiClient.post(`/partner/v1/products`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const saveDraftProduct = async (formData: FormData) => {
  return apiClient.post(`/partner/v1/products/draft`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getProductsExcelFile = async (query?: ProductSearchQuery) => {
  return apiClient.get(`/partner/v1/products/export`, {
    params: query,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const updateProduct = async (formData: FormData) => {
  const productId = formData.get('productId');
  return apiClient.put<Product>(`/partner/v1/products/${productId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateProductOption = async (props: {
  productId: string;
  body: Pick<
    Product,
    'productOptions' | 'questionOptions' | 'purchaseQuantityOptions' | 'optionLabels' | 'optionDescription'
  >;
}) => {
  return apiClient.patch(`/partner/v1/products/${props.productId}/options`, props.body);
};

export const updateProductStatus = async (props: { productId: string; status: ProductStatus }) => {
  const { productId, status } = props;
  return apiClient.patch<Product>(`/partner/v1/products/${productId}/status`, { status });
};

export const requestProductApprove = async (productId: string) => {
  return apiClient.post<Product>(`/partner/v1/products/${productId}/approve`);
};

export const deleteProduct = async (productId: string) => {
  return apiClient.delete(`/partner/v1/products/${productId}`);
};

export const getProductOptions = async (productId: string) => {
  return apiClient.get<ProductOption[]>(`/partner/v1/products/${productId}/options`);
};

export const getProductOptionsExcelFile = async (productId: string) => {
  return apiClient.get(`/partner/v1/products/${productId}/options/export`, {
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const getTempProductOptions = async (productId: string) => {
  return apiClient.get<{ productOptions: ProductOption[]; optionLabels: string[] }>(
    `/partner/v1/products/${productId}/options-temp`,
  );
};

export const deleteTempProductOptions = async (productId: string) => {
  return apiClient.delete(`/partner/v1/products/${productId}/options-temp`);
};

export const requestNaverProductOpen = async (productId: string) => {
  return apiClient.post(`/partner/v1/products/${productId}/naver-store`);
};

// 이지웰 상품 오픈 요청 일시 비활성화
// export const requestEzwelProductOpen = async (productId: string) => {
//   return apiClient.post(`/partner/v1/products/${productId}/ezwel`);
// };
